import { ca } from '@cian/analytics';

export function trackClickSimilarCollections() {
  ca('eventSite', {
    action: 'click',
    category: 'Card_JK',
    label: 'similar_collections',
    name: 'oldevent',
    useLastProducts: true,
  });
}
